import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LensHit, MatchingBlock } from "Backend";
import { USER_LOGOUT } from "redux/system.action";
import { fetchLensRun } from "./lensRun.actions";

export interface LensRunState {
  lensHits: LensHit[];
  lensHitsFullCount: number;
  lensHitsFullCountPreIdentity: number;
  matchHits: MatchingBlock[];
  matchHitsFullCount: number;
}

const initialState: LensRunState = {
  lensHits: [],
  lensHitsFullCount: 0,
  lensHitsFullCountPreIdentity: 0,
  matchHits: [],
  matchHitsFullCount: 0,
};

const lensRunSlice = createSlice({
  name: "lensrun",
  initialState,
  reducers: {
    setLensHits: (state, action: PayloadAction<{ lensHits: LensHit[] }>) => {
      state.lensHits = action.payload.lensHits;
    },
    setLensHitsAndCount: (
      state,
      action: PayloadAction<{ hits: LensHit[]; fullCount: number; fullCountPreIdentity: number }>
    ) => {
      state.lensHits = action.payload.hits;
      state.lensHitsFullCount = action.payload.fullCount;
      state.lensHitsFullCountPreIdentity = action.payload.fullCountPreIdentity;
    },
    setMatchHits: (state, action: PayloadAction<{ blocks: MatchingBlock[]; fullCount: number }>) => {
      state.matchHits = action.payload.blocks;
      state.matchHitsFullCount = action.payload.fullCount;
    },
    putHitInForm: (state, action: PayloadAction<{ hitId: number }>) => {
      const hit = state.lensHits.find((h) => h.hitId === action.payload.hitId);

      if (hit) {
        hit.blockInForm = true;
      }
    },
    removeHit: (state, action: PayloadAction<{ hitId: number }>) => {
      state.lensHits = state.lensHits.filter((h) => h.hitId !== action.payload.hitId);
      state.lensHitsFullCount--;
      state.lensHitsFullCountPreIdentity--;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLensRun.fulfilled, (state, { payload: { hits, fullCount, fullCountPreIdentity } }) => {
      state.lensHits = hits;
      state.lensHitsFullCount = fullCount;
      state.lensHitsFullCountPreIdentity = fullCountPreIdentity;
    });
    builder.addCase(USER_LOGOUT, () => {
      return { ...initialState };
    });
  },
});

export default lensRunSlice;
export const { setLensHits, setLensHitsAndCount, setMatchHits, putHitInForm, removeHit } = lensRunSlice.actions;
